export default __webpack_public_path__ + "static/media/girl_s.a238a592.png";